import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

function getAspNetCultureCookie(): string | null {
  const m = document.cookie.match(/(?:^|;\s*)\.AspNetCore\.Culture=([^;]+)/);
  if (!m?.[1]) return null;

  const v = decodeURIComponent(m[1]);
  return /uic=([^|]+)/.exec(v)?.[1] ?? /c=([^|]+)/.exec(v)?.[1] ?? null;
}

export async function bootI18n() {
  const culture = getAspNetCultureCookie() ?? navigator.language ?? 'en-US';

  const res = await fetch(`/api/i18n/${encodeURIComponent(culture)}`, {
    headers: { 'Accept-Language': culture },
  });

  if (!res.ok) {
    throw new Error(`i18n fetch failed for ${culture}: ${res.status}`);
  }

  const messages = await res.json();

  await i18n.use(initReactI18next).init({
    lng: culture,
    fallbackLng: 'en',
    resources: { [culture]: { translation: messages } },
    interpolation: { escapeValue: false },
    returnNull: false,
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em', 'span'],
    },
  });
}
